import React, { useEffect } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { useAuth } from 'auth/AuthContext';
import { setOnUnauthorized } from '../api/interceptors';
import ProfileScreen from '../screens/ProfileScreen';

export type ProfileStackParamList = {
  ProfileScreen: undefined;
};

const Stack = createNativeStackNavigator<ProfileStackParamList>();

const MainNavigator = () => {
  const { signOut } = useAuth();

  useEffect(() => {
    setOnUnauthorized(() => {
      signOut();
    });
  }, [signOut]);

  return (
    <Stack.Navigator
      screenOptions={{
        headerStyle: { backgroundColor: '#000000' },
        headerTintColor: '#FFDD00',
        headerTitleStyle: { fontWeight: '600' },
      }}
    >
      <Stack.Screen name="ProfileScreen" component={ProfileScreen} options={{ title: 'Profile' }} />
    </Stack.Navigator>
  );
};

export default MainNavigator;
